import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import { CheckCompuesto } from "components/DynamicForm/components/CheckCompuesto";
import ComboDate from "components/InputsMex/ComboDate";
import { SimpleWrapper } from "components/InputsMex/containers";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { TextInput } from "components/InputsMex/inputs";
import { SimpleCheckBox } from "components/InputsMex/SimpleInputs";
import Page from "components/Page";
import ProgressSpinner from "components/PogressSpinners/ProgressSpinner";
import useQueryParams from "hooks/useQueryParams";
import useUsuario from "hooks/useUsuario";
import moment from "moment";
import { Button as BtnInfo } from "primereact/button";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import { guardarTrackingV2 } from "utils/tracking";
import Loading from "wrappers/Loading";
import { CASUALITY } from "../constantes";
import { validarLimites } from "../constantes/funciones";
import "./styles.scss";
import { chunk } from "lodash";
import useSuscriptorFunctions from "../components/useSusciptorFunctions";
import useCustomToast from "hooks/useCustomToasts";
import { ApiKeyFetch } from "api/fetchers/apiKey";

const today = new Date();
const tomorrow = moment().add(1, "days").toDate();

const API = ApiKeyFetch.instance()

const PATHS = {
  inicioVigencia: "fechaVigenciaInicio",
  finVigencia: "fechaVigenciaFin",
  inicioDuracion: "fechaDuracionInicio",
  finDuracion: "fechaDuracionFin",
};

export const DatosGenerales = () => {
  const [loading, setLoading] = useState(false);
  const methods = useForm({ mode: "onChange" });
  const history = useHistory();
  const params = useQueryParams();
  const { id = "" } = params;
  const { reset, setError, clearErrors } = methods;
  const { cliCodigoCore = "", ...dataUsuario } = useUsuario();
  const [catalogo, setCatalogo] = useState({});
  const suscriptorFunctions = useSuscriptorFunctions();
  const vigenciaInicio = methods.watch("fechaVigenciaInicio");
  const vigenciaFin = methods.watch("fechaVigenciaFin");

  const [update, setUpdate] = useState(false);
  const [updateDuracion, setUpdateDuracion] = useState(false);
  const [mesesPlan, setMesesPlan] = useState(0);
  const { addWarningToast } = useCustomToast();

  const getFechasMoment = () => {
    return {
      inicioVigencia: moment(methods.watch(PATHS.inicioVigencia)),
      finVigencia: moment(methods.watch(PATHS.finVigencia)),
      inicioDuracion: moment(methods.watch(PATHS.inicioDuracion)),
      finDuracion: moment(methods.watch(PATHS.finDuracion)),
    };
  };

  const { vigenciaInicioMoment, vigenciaFinMoment } = useMemo(() => {
    return {
      vigenciaInicioMoment: moment(vigenciaInicio),
      vigenciaFinMoment: moment(vigenciaFin),
    };
  }, [vigenciaInicio, vigenciaFin]);

  const isVigenciaValid = useMemo(() => {
    return vigenciaFinMoment.isSameOrAfter(vigenciaInicioMoment, "date");
  }, [vigenciaInicioMoment, vigenciaFinMoment]);

  const rangosDuracion = useMemo(() => {
    if (isVigenciaValid) {
      return {
        minDate: vigenciaInicioMoment.toDate(),
        maxDate: vigenciaFinMoment.toDate(),
      };
    }

    return {
      minDate: today,
      maxDate: tomorrow,
    };
  }, [vigenciaInicioMoment, vigenciaFinMoment, isVigenciaValid]);

  const onSubmit = async (values) => {
    // console.log("SUMIT: ", values);
    // return;
    if (validateDuraciones()) {
      const {
        coberturasAdicionales,
        clausulasAdicionales,
        coberturaBasica,
        fechaDuracionFin,
        fechaDuracionInicio,
        fechaVigenciaFin,
        fechaVigenciaInicio,
        ...rest
      } = values;

      const arrMapCoberturas = catalogo?.coberturas?.map((item) => {
        return {
          ...item,
          seleccionado: values?.coberturasAdicionales?.[item?.value],
        };
      });

      const arrMapClausulas = catalogo?.clausulasAdicionales?.map((item) => {
        const clausula = {
          ...item,
          selecciono: values?.clausulasAdicionales?.[item?.value]?.selecciono === true,
        };

        if (values?.clausulasAdicionales?.[item?.value]?.informacion) {
          clausula.informacion = values?.clausulasAdicionales?.[item?.value]?.informacion;
        }
        return clausula;
      });

      rest.coberturasAdicionales = arrMapCoberturas;
      rest.clausulasAdicionales = arrMapClausulas;
      rest.coberturaBasica = catalogo?.mensajes?.coberturaBasica?.cobertura;
      rest.fechaDuracionInicio = moment(fechaDuracionInicio).format("YYYY-MM-DD");
      rest.fechaDuracionFin = moment(fechaDuracionFin).format("YYYY-MM-DD");
      rest.fechaVigenciaInicio = moment(fechaVigenciaInicio).format("YYYY-MM-DD");
      rest.fechaVigenciaFin = moment(fechaVigenciaFin).format("YYYY-MM-DD");

      guardarTrackingV2(
        params?.id || "",
        "Click Continuar pantalla 2",
        "Guardado pantalla 2",
      );
      setLoading(true);

      try {
        const Body = {
          ...rest,
          idCotizacion: params?.id,
          usuCotiza: {
            idUsuario: cliCodigoCore,
          },
        };
        const response = await API.post(CASUALITY.endpointsV2.guardarLead2, Body);
        if (response?.transaccion === true) {
          return history.push(`${CASUALITY.urls.resumen}?id=${response?.id}`);
        }
      } catch (error) { }
      setLoading(false);
      methods.reset({ ...values });
    }
  };

  const onBack = () => {
    guardarTrackingV2(
      params?.id || "",
      "Click atrás pantalla 2 Casuality",
      "Guardado Pantalla 2"
    );
    history.push(`${CASUALITY.urls.datosCliente}?id=${params?.id}`);
  };

  const init = useCallback(async () => {
    guardarTrackingV2(
      id || "",
      "Carga pantalla 2",
      "Consulta catalogo 2"
    );

    setLoading(true);
    try {
      const Body = {
        idCotizacion: id,
        usuCotiza: {
          mongoUsuario: cliCodigoCore,
        },
      };

      const [response, responseResumen] = await Promise.all([
        API.post(CASUALITY.endpointsV2.catalogo2, Body),
        API.post(CASUALITY.endpointsV2.resumen, { idCotizacion: id }),
      ]);

      console.log("RESPONSES: ", response, responseResumen);
      if (response?.transaccion === true && responseResumen?.transaccion) {
        const { redirect, link } = await suscriptorFunctions.validate({ ...responseResumen, pasoActual: "seleccionPlanEquivalencia" }, { cliCodigoCore, ...dataUsuario });
        if (redirect) { return history.push(link) };
      }

      if (response?.transaccion === true) {
        const { transaccion, ...rest } = response;
        setCatalogo({ ...rest, coberturasMapped: chunk(rest.coberturas, 4) });
        const fechasDefault = {
          fechaVigenciaFin: moment(response?.validaciones?.vigencias?.fin).toDate(),
          fechaVigenciaInicio: moment(response?.validaciones?.vigencias?.inicio).toDate(),
          fechaDuracionInicio: moment(response?.validaciones?.duracion?.inicio).toDate(),
          fechaDuracionFin: moment(response?.validaciones?.duracion?.fin).toDate(),
        };
        setMesesPlan(response?.validaciones?.nroMesesDelPlan);
        if (responseResumen?.transaccion === true && responseResumen?.carrito?.carProductos?.[0]) {
          const {
            coberturasAdicionales,
            clausulasAdicionales,
            fechaDuracionFin,
            fechaDuracionInicio,
            fechaVigenciaFin,
            fechaVigenciaInicio,
            ...restResumen
          } = responseResumen?.carrito?.carProductos?.[0];
          const mappedClausulas = {};
          const mappedCoberturas = {};
          if(coberturasAdicionales){
            coberturasAdicionales.forEach((item) => {
              mappedCoberturas[item?.value] = item?.seleccionado;
            });
          }
          if(clausulasAdicionales){
            clausulasAdicionales.forEach((item) => {
              mappedClausulas[item?.value] = { ...item };
            });
          }
          
          if (fechaVigenciaInicio) {
            fechasDefault.fechaVigenciaInicio = fechaVigenciaInicio;
            fechasDefault.fechaVigenciaFin = fechaVigenciaFin;
            fechasDefault.fechaDuracionInicio = fechaDuracionInicio;
            fechasDefault.fechaDuracionFin = fechaDuracionFin;
          }
          reset({
            clausulasAdicionales: mappedClausulas,
            coberturasAdicionales: mappedCoberturas,
            ...restResumen,
            ...fechasDefault,
          });
          console.log("res", restResumen);
        } else {
          reset(fechasDefault);
        }
      }

    } catch (error) { }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (dataUsuario.isDTC) {
      addWarningToast("Por favor, inicie sesión para continuar con la cotización");
      return history.push("/");
    }
    init();
  }, []);

  const validarDuracion = () => {
    setUpdateDuracion(true);
    const newDuracion = {};
    const {
      inicioVigencia: iniVig,
      finVigencia: finVig,
      inicioDuracion,
      finDuracion,
    } = getFechasMoment();

    const isInRangeInicio =
      inicioDuracion.isSameOrAfter(iniVig) && inicioDuracion.isSameOrBefore(finVig);
    if (!isInRangeInicio) {
      const inicioVigencia = methods.watch(PATHS.inicioVigencia);
      newDuracion[PATHS.inicioDuracion] = inicioVigencia;
      methods.setValue(PATHS.inicioDuracion, inicioVigencia);
    }

    const isInRangeFin = finDuracion.isSameOrAfter(iniVig) && finDuracion.isSameOrBefore(finVig);

    if (!isInRangeFin || mesesPlan === 12) {
      const finVigencia = methods.watch(PATHS.finVigencia);
      newDuracion[PATHS.finDuracion] = finVigencia;
      methods.setValue(PATHS.finDuracion, finVigencia);
    }

    reset({
      ...methods.watch(),
      ...newDuracion,
    });

    setTimeout(() => {
      setUpdateDuracion(false);
    }, 1000);
  };

  const validateDuraciones = () => {
    const { finDuracion, inicioDuracion } = getFechasMoment();
    if (inicioDuracion.isAfter(finDuracion, "date")) {
      setError(PATHS.inicioDuracion, {
        type: "custom",
        message: "Rango de fecha no válido",
      });

      setError(PATHS.finDuracion, {
        type: "custom",
        message: "Rango de fecha no válido",
      });
      return false;
    } else {
      clearErrors([PATHS.inicioDuracion, PATHS.finDuracion]);
      return true;
    }
  };

  const validarLimiteVigenciaFin = () => {
    const { inicioVigencia, finVigencia } = getFechasMoment();
    const maximoVigencia = inicioVigencia.add(mesesPlan, "month");
    console.log("VALIDACION: ", maximoVigencia.toDate());

    const isInRange =
      finVigencia.isSameOrAfter(inicioVigencia) && finVigencia.isSameOrBefore(maximoVigencia);

    if (!isInRange) {
      setUpdate(true);
      methods.setValue(PATHS.finVigencia, maximoVigencia.toDate());
      setTimeout(() => {
        setUpdate(false);
      }, 50);
    }
  };

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <BreadCurmb {...PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY].breadCrumb} />

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY].breadCrumbPasosCotizacion[2]}
            styleimg='height200px mr-3'
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY]?.pasosCotizacion}
          />
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <div className='d-flex flex-wrap justify-content-center'>
                <div className='col-12 col-lg-8 d-flex flex-wrap justify-content-center'>

                  <div className='form-group col-12'>
                    <SimpleWrapper
                      label='Lugar de los trabajos'
                      name='lugarTrabajos'
                      showOk={false}>
                      <TextInput
                        inputProps={{
                          name: "lugarTrabajos",
                          type: "string",
                        }}
                        rules={{
                          required: "Este campo es obligatorio",
                          validate: {
                            longitud: (value) => {
                              return validarLimites(
                                value?.length,
                                catalogo?.validaciones?.["lugarTrabajos"]?.max,
                                catalogo?.validaciones?.["lugarTrabajos"]?.min,
                                catalogo?.validaciones?.["lugarTrabajos"]?.msgError
                              );
                            },
                          },
                        }}
                        extrasClasses='hide-arrows'
                      />
                    </SimpleWrapper>
                  </div>

                  <div className='form-group col-12'>
                    <SimpleWrapper
                      label='Descripción de los trabajos*'
                      name='descripcionTrabajos'
                      showOk={false}
                      leyenda={catalogo?.validaciones?.["descripcionTrabajos"]?.leyenda}>
                      <Controller
                        name={"descripcionTrabajos"}
                        rules={{
                          required: "Este campo es obligatorio",
                          validate: {
                            longitud: (value) => {
                              return validarLimites(
                                value?.length,
                                catalogo?.validaciones?.["descripcionTrabajos"]?.max,
                                catalogo?.validaciones?.["descripcionTrabajos"]?.min,
                                catalogo?.validaciones?.["descripcionTrabajos"]?.msgError
                              );
                            },
                          },
                        }}
                        defaultValue={""}
                        render={({ onChange, value }) => {
                          return (
                            <textarea
                              rows='5'
                              cols='100'
                              className='col-12 input-area text-area-class'
                              name='descripcionTrabajos'
                              value={value}
                              onChange={(value) => {
                                onChange(value);
                              }}
                            />
                          );
                        }}
                      />
                    </SimpleWrapper>
                  </div>

                  <div className='form-group col-6 text-center'>
                    <div className='row d-flex flex-wrap col-12 '>
                      <div className='col-xl-12 col-lg-12 col-sm-12 col-md-12'>
                        <label className='accidentes text-center' style={{ fontSize: "20px" }}>
                          Vigencia
                        </label>
                        <SimpleContainer label='Inicio' name='fechaVigenciaInicio'>
                          <ComboDate
                            name='fechaVigenciaInicio'
                            rules={{
                              required: "Fecha requerida",
                            }}
                            minDate={moment(catalogo?.validaciones?.duracion?.inicio)
                              .add(-catalogo?.validaciones?.retroactividadDias, "days")
                              .format("YYYY-MM-DD")}
                            onChangeFn={() => {
                              validarLimiteVigenciaFin();
                              validarDuracion();
                            }}
                          />
                        </SimpleContainer>
                      </div>
                      <div className='col-xl-12 col-lg-12 col-sm-12 col-md-12'>
                        {!update ? (
                          <SimpleContainer label={"Fin"} name='fechaVigenciaFin'>
                            <ComboDate
                              name='fechaVigenciaFin'
                              rules={{
                                required: "Fecha requerida",
                              }}
                              defaultValue={null}
                              minDate={vigenciaInicio}
                              maxDate={moment(vigenciaInicio).add(mesesPlan, "month").toDate()}
                              disabled={mesesPlan === 12}
                              onChangeFn={() => {
                                if (mesesPlan !== 12) {
                                  validarDuracion();
                                }
                              }}
                            />
                          </SimpleContainer>
                        ) : (
                          <ProgressSpinner label={"cargando"} />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className='form-group col-6 text-center'>
                    <div className='row d-flex flex-wrap col-12'>
                      <div className='col-xl-12 col-lg-12 col-sm-12 col-md-12'>
                        <label className='accidentes text-cewnter' style={{ fontSize: "20px" }}>
                          Duración de trabajo
                        </label>
                        {!updateDuracion ? (
                          <SimpleContainer label={"Inicio"} name='fechaDuracionInicio'>
                            <ComboDate
                              name='fechaDuracionInicio'
                              rules={{
                                required: "Fecha requerida",
                              }}
                              defaultValue={null}
                              disabled={!isVigenciaValid}
                              {...rangosDuracion}
                              onChangeFn={() => {
                                validateDuraciones();
                              }}
                            />
                          </SimpleContainer>
                        ) : (
                          <ProgressSpinner label={"cargando"} />
                        )}
                      </div>
                      <div className='col-xl-12 col-lg-12 col-sm-12 col-md-12'>
                        {!update && !updateDuracion ? (
                          <SimpleContainer label={"Fin"} name='fechaDuracionFin'>
                            <ComboDate
                              name='fechaDuracionFin'
                              rules={{
                                required: "Fecha requerida",
                              }}
                              {...rangosDuracion}
                              disabled={!isVigenciaValid || mesesPlan === 12}
                              onChangeFn={() => {
                                validateDuraciones();
                              }}
                            />
                          </SimpleContainer>
                        ) : (
                          <ProgressSpinner label={"cargando"} />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className='form-group col-12 px-3 mx-3'>
                    <label className='accidentes text-cewnter py-4' style={{ fontSize: "20px" }}>
                      {catalogo?.mensajes?.coberturaBasica?.titulo}
                    </label>
                    <CheckCompuesto
                      disabled={true}
                      defaultValue={true}
                      name='coberturaBasica'
                      label={catalogo?.mensajes?.coberturaBasica?.cobertura}
                      extrasClasses='border'
                    />
                  </div>

                  <div className='form-group col-12 px-3 mx-3 mt-3'>
                    <label className='accidentes text-left py-4' style={{ fontSize: "20px" }}>
                      {catalogo?.mensajes?.coberturasAdicionales?.titulo}
                      {catalogo?.mensajes?.coberturasAdicionales?.tooltip !== null && (
                        <BtnInfo
                          type='button'
                          style={{ borderRadius: "25%" }}
                          className='p-button-text p-button-plain p-0 mx-3 font-20px'
                          tooltip={catalogo?.mensajes?.coberturasAdicionales?.tooltip ?? ""}>
                          <i className='pi pi-question-circle' style={{ fontSize: "1.7rem" }} />
                        </BtnInfo>
                      )}
                    </label>

                    <div className='d-flex flex-wrap border p-3'>
                      <div className="row justify-content-around w-100 p-3">
                        {catalogo?.coberturasMapped?.map((item, index) => {
                          return (
                            <div
                              key={index + "coberturas"}
                              className='col-md-4 col-sm-6'>
                              {item?.map((val) => {
                                return (
                                  <SimpleCheckBox
                                    label={val.label}
                                    name={"coberturasAdicionales." + val.value}
                                    defaultValue={val?.value?.check || false}
                                  />
                                );
                              })}

                            </div>
                          );
                        })}
                      </div>
                      {/* {catalogo?.coberturas?.map((val) => {
                        return (
                          <div
                            key={val.value + "coberturas"}
                            className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                            <SimpleCheckBox
                              label={val.label}
                              name={"coberturasAdicionales." + val.value}
                              defaultValue={val?.value?.check || false}
                            />
                          </div>
                        );
                      })} */}
                    </div>
                  </div>

                  <div className='form-group col-12 px-3 mx-3 mt-3'>
                    <label className='accidentes text-left py-4' style={{ fontSize: "20px" }}>
                      {catalogo?.mensajes?.clausulasAdicionales?.titulo}
                      {catalogo?.mensajes?.clausulasAdicionales?.tooltip !== null && (
                        <BtnInfo
                          type='button'
                          style={{ borderRadius: "25%" }}
                          className='p-button-text p-button-plain p-0 mx-3 font-20px'
                          tooltip={catalogo?.mensajes?.clausulasAdicionales?.tooltip ?? ""}>
                          <i className='pi pi-question-circle' style={{ fontSize: "1.7rem" }} />
                        </BtnInfo>
                      )}
                    </label>

                    <div className='d-flex flex-wrap border'>
                      {catalogo?.clausulasAdicionales?.map((val) => {
                        return (
                          <div key={val.value + "coberturas"} className='col-12 m-0 p-0'>
                            <CheckCompuesto
                              habilitaCampo={val?.habilitaCampo}
                              name={`clausulasAdicionales.${val.value}`}
                              nodoCheck='selecciono'
                              nameInfo={`clausulasAdicionales.${val.value}.informacion`}
                              label={val?.label}
                              estructura={{
                                label: val?.label,
                                value: val?.value,
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>

                </div>

                <div className='col-5 d-flex justify-content-center mt-5'>
                  <Button onClick={onBack} className='w-75 mx-3 btn-atras-api'>
                    ATRÁS
                  </Button>
                  <Button type='submit' className='w-75 mx-3'>
                    CONTINUAR
                  </Button>
                </div>

              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};
